<script>
import { useHead } from '@unhead/vue';
// Renders a page's Twitter meta data.
export default {
  name: 'TwitterMetadata',
  render() {
    // Return null since this is only rendering meta data
    return null;
  },
  props: {
    route: {
      type: Object
    }
  },
  setup(props) {
    useHead({
      meta: [
        {
          property: 'twitter:card',
          content: props.route.fields?.twitterCard?.value?.trim()
        },
        { property: 'twitter:site', content: '@CISecurity' },
        { property: 'twitter:creator', content: '@CISecurity' },
        {
          property: 'twitter:title',
          content:
            props.route.fields?.twitterTitle?.value?.trim() ||
            props.route.fields?.pageTitle?.value?.trim() ||
            'Page'
        },
        {
          property: 'twitter:description',
          content:
            props.route.fields?.twitterDescription?.value?.trim() ||
            props.route.fields?.pageDescription?.value?.trim() ||
            null
        },
        {
          property: 'twitter:image',
          content:
            props.route.fields?.twitterImage?.value?.src ||
            props.route.fields?.featuredImage?.value?.src ||
            null
        },
        {
          property: 'twitter:label1',
          content: props.route.fields?.twitterWrittenBy?.value ? 'Written by' : ''
        },
        {
          property: 'twitter:data1',
          content: props.route.fields?.twitterWrittenBy?.value || ''
        },
        {
          property: 'twitter:label2',
          content: props.route.fields?.twitterReadTime?.value ? 'Est. reading time' : ''
        },
        {
          property: 'twitter:data2',
          content: props.route.fields?.twitterReadTime?.value || ''
        }
      ].filter(
        // Remove meta items where content is not set or date is default value
        (m) => !!m.content && '0001-01-01T00:00:00Z' !== m.content
      )
    });
  }
};
</script>
